<template>
    <div style="padding:4vw;height:100%;">
        <div class="first-box" style="display: flex;flex-direction: column;align-items: center;justify-content:center;">
            <div style="font-size: 2rem;line-height: 2rem;font-weight: bold;color: #B62D2E;">{{assessmentDetail.gradeName}}{{ $t("studentProgramme.assessmentTitle") }}</div>
            <div style="display: flex;margin-top:0.5rem;margin-bottom:3vw;">
                <span style="width: 1rem;height: 1rem;background:#B62D2E;border-radius: 50%;margin:0 0.5rem;"></span>
                <span style="width: 1rem;height: 1rem;background:#DE5934;border-radius: 50%;margin:0 0.5rem;"></span>
                <span style="width: 1rem;height: 1rem;background:#F1AA55;border-radius: 50%;margin:0 0.5rem;"></span>
            </div>
            <div class="col-sm-18" style="font-size:2rem;margin-bottom:1.5vw;line-height:1.5;max-height:144px;overflow:auto;">
              {{ $t("studentProgramme.assessmentText") }}</div>
            <el-row type="flex" align="middle" justify="center" style="flex-wrap: wrap;width:100%;text-align:center;">
                <el-col :sm="4" :xs="7">
                    <img src="@/assets/images/dog2.png" style="width:100%;"/>
                </el-col>
                <el-col :sm="7" :xs="4">
                    <button @click="onAssessment" style="background: #FCC03A;box-shadow: 0px 1vw 0 #C28C00;border:none;border-radius: 5vw;font-size:3vw;padding:1.5vw 2vw;">{{ $t("studentProgramme.start") }}</button>
                </el-col>
                <el-col :sm="6" :xs="4">
                    <button @click="closeAssessment" style="background: #E0E0E0;box-shadow: 0px 1vw 0 #A1A1A1;border:none;border-radius: 5vw;font-size:3vw;padding:1.5vw 2vw;">{{ $t("studentProgramme.skip") }}</button>
                </el-col>
                <el-col :sm="4" :xs="7">
                    <img src="@/assets/images/bear3.png" style="width:100%;"/>
                </el-col>
            </el-row>
        </div>
    </div>
</template>

<script>
import {getAssessments, putAssessmentsSkip} from '@/api/assessment';
import moment from "moment";
export default {
    data() {
        return {
            assessmentDetail:{
                gradeName:null,
                name:null,
                id:null,
            }
        };
    },
    mounted() {
        if(!this.isEmpty(this.$route.query.gradeId)){
            this.getAssessments(this.$route.query.gradeId)
        }
    },
    methods:{
        getAssessments(id){
            getAssessments({gradeId:id}).then((v)=>{
                this.assessmentDetail=v.data
            })
        },
        onAssessment(){
          if(this.assessmentDetail.id == null){
            this.getAssessments(this.$route.query.gradeId)
            return;
          }

          this.$router.push({ path:'/examination', query: {'type': 'assessments', 'id': this.assessmentDetail.id, 'gradeId': this.$route.query.gradeId,startTime: moment().format('YYYY-MM-DD HH:mm:ss')} });
        },
        closeAssessment(){
          if(this.assessmentDetail.id == null){
            this.getAssessments(this.$route.query.gradeId)
            return;
          }
            putAssessmentsSkip(this.assessmentDetail.id,{isSkip:true}).then(()=>{
                this.$router.push({ name: "adventure" });
                //this.$emit('reload')
            })
        }
    }
};
</script>

<style lang="scss" scoped>
.first-box{
    border-radius: 4.5rem;
    background: #ffffff;
    width:100%;
    height: 100%;
}
.button{
    background: #FCC03A;
    box-shadow: 0px 0.5rem 0 #C28C00;
    border:none;
    border-radius: 2.75rem;
    font-size:2rem;
    padding:0.75rem 3rem;
}
</style>